import request from '@/utils/request'

const base = '/db/compute';

//时长算法配置查询
export function computeConfigQuery(query){
    return request({
        url: base+'/query',
        method:'get',
        params:query
    })
}

//时长算法配置 新增/修改
export function update(data){
    return request({
        url: base+'/update',
        method:'post',
        data
    })
}